import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useClassTypesQuery, useDeleteClassType } from "../api/queries";
import { ClassTypesFilter } from "../ui/class-types/ClassTypesFilter";
import { ClassTypesTable } from "../ui/class-types/ClassTypesTable";
import { ClassTypesToolbar } from "../ui/class-types/ClassTypesToolbar";

export function ClassTypesPage() {
  const nav = useNavigate({ from: "/app/master/class-types" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/master/class-types",
  });

  const list = useClassTypesQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["master:create"]);
  const deleteClassType = useDeleteClassType();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ປະເພດຄລາດສ໌" },
          ]}
        />
      </Header>

      <Main>
        <ClassTypesToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/master/class-types/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ClassTypesFilter />

          <ClassTypesTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(classType) =>
              nav({
                to: "/app/master/class-types/$id/edit",
                params: { id: classType.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteClassType.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບປະເພດຄລາດສ໌ສຳເລັດ",
                error: "ລຶບປະເພດຄລາດສ໌ລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
